import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <header className="max-w-3xl mx-auto px-6 md:px-10 pt-10 pb-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs text-[#6B7280] hover:text-[#1E3B2F]"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={12} /> Back to Gentry
        </Link>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1E3B2F] mt-6">
          {title}
        </h1>
        <div className="font-label text-[10px] text-[#6B7280] mt-3">
          Gens Realty · Houston, TX · Last updated {new Date().toLocaleDateString()}
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 md:px-10 pb-24 prose-content">
        <article className="bg-white rounded-2xl border border-[#EBE4D3] p-8 md:p-10 shadow-sm text-[#1F1F1F] text-sm leading-relaxed space-y-6">
          {children}
        </article>
      </main>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-serif-display text-2xl text-[#1E3B2F]">{heading}</h2>
      <div className="space-y-3 text-[#3d3d3d]">{children}</div>
    </section>
  );
}
